export default __webpack_public_path__ + "static/media/sign-out.3188c733.svg";